/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Cta_TextInputs */



/**
* | output |
* | --- |
* | "Tell us about the vessel and what you need." |
*
* @param {Contact_Cta_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_cta_text = /** @type {((inputs?: Contact_Cta_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Cta_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("告诉我们船舶情况和您的需求。")
	return /** @type {LocalizedString} */ ("Tell us about the vessel and what you need.")
});